var slickInit;

(function ($) {

	const selectors = {
		'prevArrow': '[data-slick-prev]',
		'nextArrow': '[data-slick-next]',
	};

	slickInit = function () {

		$(document).on('click', '.slick-cloned [data-fancybox]', function (e) {
			e.preventDefault();
			const $link = $(e.currentTarget);
			const $slide = $link.closest('.slick-slide');
			const $slides = $slide.siblings().not('.slick-cloned');
			const slideNum = ($slide.attr("data-slick-index") || 0) % ($slides.length);

			const $targetElem = $slides.eq(slideNum).find('[data-fancybox]');

			const event = new MouseEvent('click', {
				view: window,
				bubbles: true,
				cancelable: true
			});

			$targetElem.get(0).dispatchEvent(event);

		});

		new SlickSlider('.c-large-tiles__slider', {
			autoplaySpeed: 5000,
			speed: 700,
			autoplay: true,
			dots: true,
			arrows: false,
			pauseOnHover: false,
			mobileFirst: true,
			swipeToSlide: true,
			slidesToShow: 1,
			infinite: true,
			// swipe: false,

			responsive: [
				{
					breakpoint: 600 - 1,
					settings: {
						slidesToShow: 2
					}
				},
				{
					breakpoint: 900 - 1,
					settings: {
						slidesToShow: 3
					}
				},
			],

		});

		new SlickSlider('.c-product-tiles__slider', {
			autoplaySpeed: 5000,
			speed: 700,
			autoplay: true,
			dots: true,
			arrows: false,
			pauseOnHover: false,
			mobileFirst: true,
			swipeToSlide: true,
			slidesToShow: 2,
			infinite: true,
			// swipe: false,

			responsive: [
				{
					breakpoint: 600 - 1,
					settings: {
						slidesToShow: 3
					}
				},
				{
					breakpoint: 900 - 1,
					settings: {
						slidesToShow: 4
					}
				},
			],

		});

		new SlickSlider('.c-testimonials__slider--side', {
			autoplaySpeed: 5000,
			speed: 700,
			autoplay: true,
			dots: false,
			arrows: false,
			pauseOnHover: false,
			mobileFirst: true,
			swipeToSlide: true,
			slidesToShow: 1,
			infinite: true,
			// swipe: false,

			responsive: [
				{
					breakpoint: 600,
					settings: {
						slidesToShow: 2
					}
				},
			],

		});
		new SlickSlider('.c-testimonials__slider--below', {
			autoplaySpeed: 5000,
			speed: 700,
			autoplay: true,
			dots: false,
			arrows: true,
			pauseOnHover: false,
			mobileFirst: true,
			swipeToSlide: true,
			slidesToShow: 1,
			infinite: true,
			// swipe: false,

			responsive: [
				{
					breakpoint: 600,
					settings: {
						slidesToShow: 2
					}
				},
				{
					breakpoint: 900,
					settings: {
						slidesToShow: 3
					}
				},
			],

		});

		new SlickSlider('.c-text-media__media--slider', {
			autoplaySpeed: 5000,
			speed: 700,
			autoplay: true,
			dots: true,
			arrows: false,
			pauseOnHover: false,
			mobileFirst: true,
			swipeToSlide: true,
			// swipe: false,
		});

		new SlickSlider('.c-configuration__slider', {
			autoplaySpeed: 5000,
			speed: 700,
			autoplay: true,
			dots: true,
			arrows: false,
			pauseOnHover: false,
			mobileFirst: true,
			swipeToSlide: true,
			// swipe: false,
		});



	}
	class SlickSlider {

		constructor(el, options) {

			this.$slider = $(el);

			this.events = options.events || false;
			delete options.events;

			this.options = options;

			if (this.$slider.length) {
				this.bind();
				this.init();
			}
		}

		bind() {
			this.onResize = this.onResize.bind(this);

			const $section = this.$slider.closest('section');
			const $navItems = $section.find('[data-slick-nav]');

			$(window).on('resize', this.onResize);

			const self = this;
			if (self.events) {
				$.each(self.events, (event, callback) => {
					self.$slider.on(event, callback);
				});
			}

			if ($navItems.length) {
				// Handle slide changes with afterChange event
				this.$slider.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
					$section.find('[data-slick-nav]').removeClass('is-active');
					$section.find('[data-slick-nav="' + nextSlide + '"]').addClass('is-active');
				});

				// Add click handlers for navigation items
				$navItems.on('click', (e) => {
					e.preventDefault();
					const slideIndex = $(e.currentTarget).data('slick-nav');
					this.$slider.slick('slickGoTo', slideIndex);
					// $navItems.removeClass('is-active');
					// $(e.currentTarget).addClass('is-active');
				});

				// Set initial active state for first nav item
				$section.find('[data-slick-nav="0"]').addClass('is-active');
			}

		}

		init() {

			const $section = this.$slider.closest('section');


			if ($section.find(selectors.prevArrow)) {
				this.options.prevArrow = $section.find(selectors.prevArrow);
			}
			if ($section.find(selectors.nextArrow)) {
				this.options.nextArrow = $section.find(selectors.nextArrow);
			}

			this.$slider.slick(this.options);
		}

		onResize() {
			// console.log('hello');
			if (!this.$slider.hasClass('slick-initialized')) {
				this.init();
			}
		}


	}

})(jQuery);

export default slickInit;